module.exports = "<p>\n  test8 works!\n</p>\n"